import Permissions from 'components/Permissions';
import Tooltip from 'components/Tooltip';
import { NEW_EDIT_ICON } from 'constants/commonIcons';
import React from 'react';

type WidgetEmptyStateProps = {
  widgetTitle?: string;
  msg?: string;
  handleEditWidget?: () => void;
  editMode?: boolean;
};

const WidgetEmptyState: React.FC<WidgetEmptyStateProps> = (props) => {
  const { widgetTitle, msg = 'No data to show', editMode, handleEditWidget } = props;

  return (
    <div className="h-full w-full">
      <div className="flex flex-row gap-1">
        {widgetTitle && <span className="text-menu-item">{widgetTitle}</span>}
        {!editMode && handleEditWidget && (
          <Permissions action="analytics.editWidget" key="edit-button">
            <Tooltip tooltip="dashboard.editWidget">
              <button
                type="button"
                className="focus:outline-none w-3"
                onClick={(): void => {
                  handleEditWidget();
                }}
              >
                {NEW_EDIT_ICON('text-litlingo-gray-6')}
              </button>
            </Tooltip>
          </Permissions>
        )}
      </div>
      <div className="flex justify-center items-center h-full w-full">
        <span className="text text--extra-large">{msg}</span>
      </div>
    </div>
  );
};

export default WidgetEmptyState;
